import { render, staticRenderFns } from "./MUploadFile.vue?vue&type=template&id=36c4b4d3"
import script from "./MUploadFile.vue?vue&type=script&lang=js"
export * from "./MUploadFile.vue?vue&type=script&lang=js"
import style0 from "./MUploadFile.vue?vue&type=style&index=0&id=36c4b4d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports